<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="full-height">
    <div class="border-bottom border-gray d-flex align-items-center justify-content-center mt-3 pb-3 mb-0 h5" i18n>
        <i class="ni ni-badge mr-3 "></i>
        Roles
    </div>
    <div class="px-5 py-4 border-bottom border-gray bg-lighter">
        <div class="content-wrapper">
            <button class="btn btn-link text-info d-flex align-items-center justify-content-center p-0 mb-2 font-weight-normal"
                [routerLink]="'../'" i18n>
                <i class="ni ni-bold-left mr-1"></i> Back
            </button>
            <div class="d-flex justify-content-between">
                <h2 class="display-2" i18n>Assign Users To Role</h2>
                <p class="text-secondary" i18n>1 of 2</p>
            </div>
        </div>
    </div>
    <div class="p-5 mb-4 border-bottom flex-1">
        <div class="content-wrapper">
            <h3 class="mb-4 font-weight-bold" i18n>Assign user(s) for {{ (role$ | async)?.name }}</h3>

            <app-data-table-ajax 
                columnMode="force" 
                url="/users" 
                limit="8" 
                responseKey="users"
                selectedItemKey="username"
                [excludedItems]="roleUsers$ | async"
                [columns]="userTableColumns"
                selectionType="multiClick" (rowClicked)="onSelectUser($event)">
            </app-data-table-ajax>
        </div>

    </div>
    <div class="px-5 mb-3">
        <div class="content-wrapper d-flex justify-content-between width-100">
            <button class="mr-auto btn btn-link-default" (click)="cancel()" i18n>
                Cancel
            </button>
            <button class="btn btn-info btn-size-normal" 
                    [routerLink]="['./', 'scope']" 
                    [disabled]="!isValid()"
                (click)="selectUsers()" i18n>
                Next
            </button>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-users-form/role-users-form.component.html